import React from 'react';

interface Props {
    children: React.ReactNode;
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
}

function Form({ children, onSubmit }: Props): React.ReactElement {
    return <form onSubmit={onSubmit}>{children}</form>;
}

export default Form;
